import { AuthenticationService, SignupService } from '@nuskin/ns-account';

// Translations come from the aem wrapper component
const state = {
  user: {}
};

const getters = {

};

const mutations = {
  setUser(state, user) {
    if (user) {
      state.user = user;
    }
  }
};

const actions = {
  async guestSignup({ commit }, guestObj) {
    try {
      let user = await AuthenticationService.guestSignup(guestObj);
      if (user) {
        commit('setUser', user);
        return user;
      }
    } catch (err) {
      console.error(`Guest Signup Failed ${err}`);
      return null;
    }
  },
  async accountExists({ commit }, email) {
    try {
      return !await SignupService.isUsernameAvailable(email);
    } catch (err) {
      console.error(`Failed to check if account exists ${err}`);
      return false;
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
